app.service("ProductPanelService", ['$rootScope', 'ProductService', function ($rootScope, ProductService) {

    const siteHelper = $rootScope.site_helper;
    const modelConstructor = $rootScope.model_constructor;

    const defaultThickness = 18;

    const ProductPanelModel = modelConstructor.extend(ProductService.BasicProductModel, {
        id: "product_panel",
        base_component_id: "panel",
        request_range_id: "bella",
        applyItemHandler: applyItemHandler,
        is_single_item_model: true,
        is_circular: false,
        available_thicknesses: [18, 25]
    });

    this.factory = new ProductService.BasicProductModelFactory({
        birth: function (values) {
            return new ProductPanelModel(values);
        },
        validVariationPointers: function (variationIDs) {
            return ['browse_id', 'site_range_id', 'style_id', 'parent_category_id'];
        },

        applyModelVariation: applyModelVariation
    });

    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;
        const parentCategoryID = variationIDs.parent_category_id;


        if (parentCategoryID === "panel_top_round") {
            siteHelper.applyValues(model, {
                is_circular: true
            });
        }
    }

    function applyItemHandler(product) {
        this.super(product);

        const model = this.root;

        const parentCategoryID = product.parent_category_id;

        let localOptionTermConfig = [];

        let thisDefaultThickness = defaultThickness;
        if (product.thicknesses) {
            const validThicknesses = [];
            for (let thickness in product.thicknesses) {
                thickness = $rootScope.site_helper.isNumber(thickness) ? parseInt(thickness) : thickness;
                if (model.available_thicknesses.indexOf(thickness) !== -1) {
                    validThicknesses.push(thickness)
                }
            }
            if (validThicknesses.length) {
                model.available_thicknesses = validThicknesses;
                if (validThicknesses.indexOf(defaultThickness) === -1) {
                    thisDefaultThickness = validThicknesses[0];
                }
                if (model.available_thicknesses.length === 1) {
                    const fromThickness = product.thicknesses[model.available_thicknesses[0]];
                    if (fromThickness.options && !product.options) {
                        product.options = fromThickness.options
                    }
                }
            }
        }

        if (parentCategoryID === "panel_edge_profiled") {

            localOptionTermConfig = localOptionTermConfig.concat([
                {
                    option_id: "panel_profiled_edge",
                    required: true
                }
            ]);
        } else if (parentCategoryID === "panel_top_angled") {

            localOptionTermConfig = localOptionTermConfig.concat([
                {
                    option_id: "panel_angle",
                    required: true
                },
                {
                    option_id: "panel_profiled_edge"
                }
            ]);
        } else if (parentCategoryID === "panel_top_corner") {

            localOptionTermConfig = localOptionTermConfig.concat([
                {
                    option_id: "panel_corner_position",
                    required: true
                },
                {
                    option_id: "panel_side_angle",
                    required: false
                },
                {
                    option_id: "panel_corner_radius"
                },
                {
                    option_id: "panel_corner_profile"
                }
            ]);
        } else if (parentCategoryID === "panel_top_radius") {

            localOptionTermConfig = localOptionTermConfig.concat([
                {
                    option_id: "panel_radius",
                    required: true
                },
                {
                    option_id: "panel_profiled_edge"
                }
            ]);
        }

        product.local_option_term_config = localOptionTermConfig;

        let groupName = product.name;
        if (!groupName) {
            const componentObject = $rootScope.service.cache_local_server.getComponentObject(product.base_component_id, product.parent_category_group_id, product.parent_category_id);
            groupName = componentObject && componentObject.name ? componentObject.name : product.api_code;
        }
        product.group_name = groupName;

        siteHelper.applyValues(product, {
            option_layout: "list",
            quantity: 1,
            length: '',
            depth: '',
            diameter: '',
            applynonstdsurcharge: false,
            profiled_f: false,
            profiled_b: false,
            profiled_l: false,
            profiled_r: false,
            front_left_angle: false,
            front_right_angle: false,
            back_left_angle: false,
            back_right_angle: false,
            front_left_radius: '',
            front_right_radius: '',
            back_left_radius: '',
            back_right_radius: '',
            corner_position: '',
            side_length: '',
            side_depth: '',
            angle_length: '',
            angle_depth: '',
            corner_radius: '',
            middle_radius: '',
            side_length_profiled: false,
            side_depth_profiled: false,
            thickness: thisDefaultThickness,
            default_thickness: thisDefaultThickness,
            available_thicknesses: model.available_thicknesses,
            is_circular: model.is_circular,

            thicknessProduct: function () {
                const subProduct = product.thickness && product.thicknesses ? product.thicknesses[product.thickness] : null;
                return subProduct ? subProduct : product;
            },

            applyThicknessCosts: function () {
                const thicknessProduct = product.thicknessProduct();
                if (thicknessProduct === product) {
                    return;
                }
                product.base_price = thicknessProduct.price;
                product.discount_group = thicknessProduct.discount_group;
                product.current_surcharge = thicknessProduct.surcharge;
                product.requires_colour = thicknessProduct.requires_colour;
                product.requires_style = thicknessProduct.requires_style;
                product.apply_style_surcharge = thicknessProduct.apply_style_surcharge;
                product.apply_colour_surcharge = thicknessProduct.apply_colour_surcharge;
                product.minimum_price = thicknessProduct.minimum_price;
            },

            collectImageParams: function () {
                const params = this.super();

                params.image_type_id = "product";
                params.api_code = product.api_code;
                params.site_range_id = $rootScope.navigation_model.state_ids.site_range_id;
                params.colour_id = $rootScope.navigation_model.state_ids.colour_id;
                params.style_id = $rootScope.navigation_model.state_ids.style_id;

                params.height = product.height;
                params.width = product.width;
                params.length = product.length;
                params.depth = product.depth;

                let angleLength = product.option_term_values.panel_angle ? product.option_term_values.panel_angle.angle_length : null;
                let angleDepth = product.option_term_values.panel_angle ? product.option_term_values.panel_angle.angle_depth : null;

                if (!angleLength && !angleDepth) {
                    angleLength = product.option_term_values.panel_side_angle ? product.option_term_values.panel_side_angle.angle_length : null;
                    angleDepth = product.option_term_values.panel_side_angle ? product.option_term_values.panel_side_angle.angle_depth : null;
                }

                params.front_profiled = product.option_term_values.panel_profiled_edge ? product.option_term_values.panel_profiled_edge.front_profiled : null;
                params.back_profiled = product.option_term_values.panel_profiled_edge ? product.option_term_values.panel_profiled_edge.back_profiled : null;
                params.left_profiled = product.option_term_values.panel_profiled_edge ? product.option_term_values.panel_profiled_edge.left_profiled : null;
                params.right_profiled = product.option_term_values.panel_profiled_edge ? product.option_term_values.panel_profiled_edge.right_profiled : null;

                params.angle_length = angleLength;
                params.angle_depth = angleDepth;
                params.front_left_angle = product.option_term_values.panel_angle ? product.option_term_values.panel_angle.front_left_angle : null;
                params.front_right_angle = product.option_term_values.panel_angle ? product.option_term_values.panel_angle.front_right_angle : null;
                params.back_left_angle = product.option_term_values.panel_angle ? product.option_term_values.panel_angle.back_left_angle : null;
                params.back_right_angle = product.option_term_values.panel_angle ? product.option_term_values.panel_angle.back_right_angle : null;

                params.front_left_radius = product.option_term_values.panel_radius ? product.option_term_values.panel_radius.front_left_radius : null;
                params.front_right_radius = product.option_term_values.panel_radius ? product.option_term_values.panel_radius.front_right_radius : null;
                params.back_left_radius = product.option_term_values.panel_radius ? product.option_term_values.panel_radius.back_left_radius : null;
                params.back_right_radius = product.option_term_values.panel_radius ? product.option_term_values.panel_radius.back_right_radius : null;

                params.corner_position = product.option_term_values.panel_corner_position ? product.option_term_values.panel_corner_position.corner_position : null;

                params.side_length = product.option_term_values.panel_side_angle ? product.option_term_values.panel_side_angle.side_length : null;
                params.side_depth = product.option_term_values.panel_side_angle ? product.option_term_values.panel_side_angle.side_depth : null;

                params.corner_radius = product.option_term_values.panel_corner_radius ? product.option_term_values.panel_corner_radius.corner_radius : null;
                params.middle_radius = product.option_term_values.panel_corner_radius ? product.option_term_values.panel_corner_radius.middle_radius : null;

                params.side_length_profiled = product.option_term_values.panel_corner_profile ? product.option_term_values.panel_corner_profile.side_length_profiled : null;
                params.side_depth_profiled = product.option_term_values.panel_corner_profile ? product.option_term_values.panel_corner_profile.side_depth_profiled : null;

                return params;
            },
            finalPrice: function () {
                return finalPrice(product);
            }
        });

    }

    function finalPrice(product) {
        if (product.is_circular) {
            if (!product.diameter) {
                return 0;
            }
        } else if (!product.length || !product.depth) {
            return 0;
        }
        product.applyThicknessCosts();
        return $rootScope.service.product.finalPrice(product);
    }

}]);